module.exports = __webpack_public_path__ + "static/media/2_The inner voice_RU.45a76f85.txt";